import * as Mixins from './mixins';
import * as Plugins from './plugins';
import * as Utilities from './utilities';

export const i18n = {
    Mixins,
    Plugins,
    Utilities
};
